import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  getForm,
  createValidateObject,
  storeRecoveryFieldValues,
  storeSetFieldValue,
  storeSetFieldsErrors
} from '../../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

export const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
export const SEND_FORM = 'SEND_FORM';
export const RECOVERY_FIELDS = 'RECOVERY_FIELDS';
export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
export const SET_SEND_FORM_RESPONSE = 'SET_SEND_FORM_RESPONSE';

export const CHANGE_FIELD_CURRENT_PASSWORD = 'CHANGE_FIELD_CURRENT_PASSWORD';
export const CHANGE_FIELD_NEW_PASSWORD = 'CHANGE_FIELD_NEW_PASSWORD';
export const CHANGE_FIELD_CONFIRM_PASSWORD = 'CHANGE_FIELD_CONFIRM_PASSWORD';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        current_password: {
          title: 'Текущий пароль',
          inValue: '',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        new_password: {
          title: 'Новый пароль',
          inValue: '',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        },
        confirm_password: {
          title: 'Новый пароль еще раз',
          inValue: '',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        }
      },
      errors: [],
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, RECOVERY_FIELDS):
        return storeRecoveryFieldValues(state, action.payload);
      case createActionName(name, SEND_FORM):
        return setRequestStateInProgress(state);
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state;
      case createActionName(name, SET_SEND_FORM_RESPONSE):
        return state.merge({
          resultObject: action.payload
        });

      case createActionName(name, CHANGE_FIELD_CURRENT_PASSWORD): {
        return storeSetFieldValue(state, 'current_password', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_NEW_PASSWORD): {
        return storeSetFieldValue(state, 'new_password', action.payload);
      }
      case createActionName(name, CHANGE_FIELD_CONFIRM_PASSWORD): {
        return storeSetFieldValue(state, 'confirm_password', action.payload);
      }

      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS
export const initState = reducerName => ({
  type: createActionName(reducerName, INIT_STATE)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const recoveryFields = (reducerName, payload) => ({
  type: createActionName(reducerName, RECOVERY_FIELDS),
  payload
});
export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, SEND_FORM),
  payload
});
export const setErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_ERRORS),
  payload
});
export const clearAllErrors = (reducerName, payload) => ({
  type: createActionName(reducerName, CLEAR_ALL_ERRORS),
  payload
});
export const setSendFormResponse = (reducerName, payload) => ({
  type: createActionName(reducerName, SET_SEND_FORM_RESPONSE),
  payload
});
// FIELDS
export const changeFieldCurrentPassword = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_CURRENT_PASSWORD),
  payload
});
export const changeFieldNewPassword = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_NEW_PASSWORD),
  payload
});
export const changeFieldConfirmPassword = (reducerName, payload) => ({
  type: createActionName(reducerName, CHANGE_FIELD_CONFIRM_PASSWORD),
  payload
});

// SELECTORS
export const selectState = (state, reducerName) => getState(state, reducerName);
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');

export const selectFormBody = (state, reducerName) =>
  getForm(getState(state, reducerName));

export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');

// Fields
export const selectFieldCurrentPassword = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.current_password');
export const selectFieldNewPassword = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.new_password');
export const selectFieldConfirmPassword = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.confirm_password');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/changePasswordForm.js